import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ConfirmModalDeliveryNotes = ({
  modalOpen,
  toggleModal,
  modalData,
  performModalFunction,
}) => {
  const [error, setError] = useState("");

  const handleConfirm = () => {
    // ✅ Validation: Bestellnummer required if YES selected
    if (modalData.showOrderInput && !modalData.orderNumber?.trim()) {
      setError("Bestellnummer is required");
      return;
    }

    setError("");
    performModalFunction();
  };

  return (
    <Modal isOpen={modalOpen} toggle={toggleModal} centered>
      <ModalHeader toggle={toggleModal}>
        {modalData?.header || "Confirmation"}
      </ModalHeader>

      <ModalBody>
        <p>Do you want to insert Bestellnummer?</p>

        {/* YES / NO */}
        <div className="d-flex gap-3 mb-3">
          <Button
            color={modalData.showOrderInput ? "primary" : "secondary"}
            size="sm"
            onClick={() => {
              modalData.setShowOrderInput(true);
              setError("");
            }}
          >
            Yes
          </Button>

          <Button
            color={!modalData.showOrderInput ? "primary" : "secondary"}
            size="sm"
            onClick={() => {
              modalData.setShowOrderInput(false);
              modalData.setOrderNumber("");
              setError("");
            }}
          >
            No
          </Button>
        </div>

        {/* Order Number Input */}
        {modalData.showOrderInput && (
          <div>
            <label className="fw-bold mb-1">Bestellnummer</label>
            <input
              type="text"
              className={`form-control ${error ? "is-invalid" : ""}`}
              placeholder="Enter Bestellnummer"
              value={modalData.orderNumber}
              onChange={(e) => {
                modalData.setOrderNumber(e.target.value);
                setError("");
              }}
            />
            {error && <div className="text-danger small mt-1">{error}</div>}
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" size="sm" onClick={toggleModal}>
          Cancel
        </Button>

        <Button
          color="primary"
          size="sm"
          onClick={handleConfirm}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModalDeliveryNotes;
